import { render, staticRenderFns } from "./adressbuch.vue?vue&type=template&id=3c53be02&scoped=true&"
import script from "./adressbuch.vue?vue&type=script&lang=js&"
export * from "./adressbuch.vue?vue&type=script&lang=js&"
import style0 from "./adressbuch.vue?vue&type=style&index=0&id=3c53be02&prod&lang=css&"
import style1 from "./adressbuch.vue?vue&type=style&index=1&id=3c53be02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53be02",
  null
  
)

export default component.exports